const initTooltip = () => {
    const tooltipTriggers = document.querySelectorAll('.tease__action')
    let activeTooltip = false

    for (const tooltipTrigger of tooltipTriggers) {
        tooltipTrigger.addEventListener('click', function (event) {
            let tooltip = this.nextElementSibling

            if (activeTooltip != false) {
                if (activeTooltip != tooltip) {
                    activeTooltip.classList.remove('tooltip--active')
                    activeTooltip = false
                }
            }
            toggleTooltip(tooltip)
        })
    }

    const toggleTooltip = (element) => {
        activeTooltip = element
        activeTooltip.classList.toggle('tooltip--active')
    }
}
